<template>
  <div class="projects-container">
    <el-row>
      <el-col :span="8" v-bind:key="project.id" v-for="project in projects">
        <el-card :body-style="{ padding: '0px' }">
          <img
            class="project-preview"
            :src="project.previewPath"
            :alt="project.name">
          <div class="project-description">
            {{ project.name }}
            <el-button plain class="button-details" @click="updateProject(project.id)">
              Details
            </el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card :body-style="{ padding: '0px' }">
          <div class="new-project-card">
            <i class="el-icon-plus"></i>
            <p>Create new project</p>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    chosenProjectID: 0,
    projects: [
      {
        id: 1,
        name: 'Test project #1',
        previewPath: '../../static/brandify-screenshot.png',
      },
      {
        id: 2,
        name: 'Test project #2',
        previewPath: '../../static/brandify-screenshot.png',
      },
    ],
  }),
  methods: {
    updateProject(id) {
      this.$emit('updateProject', id);
    },
  },
};
</script>

<style lang="scss">
.projects-container {
  position: absolute;
  top: 70px;
  right: 0;
  padding: 0 30px;

  .el-col-8 {
    padding: 40px 30px 0 30px;

    .el-card {
      position: relative;
      cursor: pointer;
      box-shadow: 0 0 0 0 #FFFFFF;
      transition: box-shadow 2s ease;
      transition: transform .3s ease;

      &__body {
        height: 250px;
      }

      &:hover {
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        transform: translate(0, -2px);
      }

      .project-preview {
        width: 100%;
      }

      .project-description {
        padding: 20px 15px;
        text-align: left;
        font-family: 'Quicksand', sans-serif;
        font-size: 1.4rem;
      }

      .new-project-card {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        i {
          font-size: 40px;
          color: #aaaaaa;
          transition: color .3s ease;
        }

        p {
          font-size: 16px;
          margin-bottom: 0;
          transition: color .3s ease;
        }

        &:hover > i,
        &:hover > p {
            color: #409EFF;
        }
      }
    }
  }

  .button-details {
    position: absolute;
    right: 15px;
    bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue